<template>
  <div class="uk-background-default" uk-sticky >
    <nav class="uk-container uk-container-expand" uk-navbar="dropbar: true;">
      <div class="uk-navbar-left ma-2">
        <a href="/" style="background: #fff;">
          <img 
            :src="tipoLogo=='0' ? require('../assets/logo_cuseremp.svg'): require('../assets/logo_cuseremp_black.svg')" 
            style="height:70px; padding: 5px;"
          >
        </a>
      </div>
      <div class="uk-navbar-left" style="z-index:100">

      </div>
      <div class="uk-navbar-right menu-custom">
        <ul class="uk-navbar-nav">
          <li v-for="page in menu.items" :key="page.slug">
            <a 
              v-if="page.__typename=='ComponentMenuLink'"
              :href="page.link"
            >
              {{ page.title }}
            </a>
            <a
              v-else-if="page.__typename=='ComponentMenuSinglePage'"
              :href="`/${page.single_page.slug}`"
            >
              {{ page.single_page.title }}
            </a>
            <template v-else-if="page.__typename=='ComponentMenuClass'">
              <a href="#">{{ page.title }}</a>
              <div class="uk-navbar-dropdown uk-navbar-dropdown-width-2 menu-background" uk-drop="boundary: !nav; boundary-align: true; pos: bottom-justify;">
                <div class="uk-navbar-dropdown-grid uk-child-width-1-2" uk-grid>
                    <div v-for="itemClass in page.classes" :key="itemClass.title">
                        <ul class="uk-nav uk-navbar-dropdown-nav">
                            <li class="uk-nav-header classPage">{{ itemClass.name }}</li>
                            <li class="uk-nav-header" 
                              v-for="itemCategory in itemClass.categories" :key="itemCategory.name"
                            >
                              <span>{{ itemCategory.name }}</span>
                              <ul class="uk-nav uk-navbar-dropdown-nav">
                                <li class="nonUcases" v-for="itemPage in itemCategory.pages" :key="itemPage.slug">
                                  <a :href="`/${itemPage.slug}?class=${itemClass.name}`">{{ itemPage.title }}</a>
                                </li>
                              </ul>
                            </li>
                        </ul>
                    </div>
                </div>
              </div>
            </template>
            
          </li>
        </ul>
        <a class="round-30 border-secondary uk-button uk-button-default" href="/contact">Contáctenos</a>
      </div>
      
        
      
    </nav>
  </div>
</template>

<script>
import gql from "graphql-tag";

export default {
  name: "Nav",
  data() {
    return {
      categorias: [],
      menu: {},
      class: null
    };
  },
  watch: { 
    '$route.query': {
      handler: function(search) {
        if (search.class){
          this.class = search.class
        }else{
          this.class = null
        }
        console.log(search)
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    tipoLogo(){
      return this.class=="Gestión Pública" ? "1" : "0"
    }
  },
  apollo: {
    menu: gql`
      query MENU{
        menu{
          items{
            __typename
            ... on ComponentMenuLink{
              title
              link
            }
            ... on ComponentMenuSinglePage{
              single_page{
                title
                slug
              }
            }
            ... on ComponentMenuClass{
              title
              classes{
                name
                categories{
                  name
                  pages{
                    title
                    slug
                  }
                }
              }
            }
          }
        }
      }
    `
  }
};
</script>

<style scoped>
  .pl-2{
    padding-left:20px;
  }
  .pl-4{
    padding-left:40px;
  }
  .pr-1{
    padding-right:10px;
  }
  .round-30{
    border-radius:30px;
  }
  .ma-2{
    margin: 20px;
  }
  .border-primary{
    border: 1px solid #ff4949ff;
  }
  .border-secondary{
    border: 1px solid #ff834fff;
  }
  .uk-navbar-nav>li>a:hover {
    color: #ff4949ff!important;
  }
  .uk-navbar-nav>li>a {
    text-transform: none;
  }
  .classPage {
    text-decoration: underline;
  }
  .nonUcases{
    text-transform: none;
  }
  .menu-background{
    background: #f2f2f2;
    overflow: auto;
    max-height: 400px;

  }
  .menu-custom li a{
    /* color: #fff!important; */
    font-size: 1rem!important;
  }
  .uk-light li a{
    color: #fff;
  }
</style>